import React, { memo, useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import BMDotLoader from '../DotLoader';
import { useBMTheme } from '../../theme';
import { BMText } from '../..';
import useDateCellAdditionalSlotRenderer from './useDateCellAdditionalSlotRenderer';
function DateCellAdditionalSlot({ type, item, loading = false, ink = 'BMStyleIconInkSecondary', position = 'bottom', }) {
    const { activeTheme, BMComponents } = useBMTheme();
    const [styles, setStyles] = useState(() => componentStyles(BMComponents));
    const component = useDateCellAdditionalSlotRenderer(type);
    const validPositions = ['top', 'bottom'];
    const safePosition = validPositions.includes(position) ? position : 'bottom';
    const containerStyle = [styles.container, styles[safePosition + 'Container']];
    useEffect(() => {
        setStyles(componentStyles(BMComponents));
    }, [activeTheme]);
    // (1) Loading state
    // If in loading state, show a loader
    if (loading) {
        return (<View style={containerStyle}>
        <BMDotLoader color={BMComponents.BMUiIndicatorLoaderRailsBgcolor}/>
      </View>);
    }
    const renderAdditionalComponent = () => {
        // (2) Check component type
        // If type is valid component type, render it
        if (component) {
            return component;
        }
        // (3) Item is a string
        // If item is a string, render it as text
        if (typeof item === 'string') {
            return (<BMText variant={'uiSmall'} ink={ink} style={styles.textInformation}>
          {item}
        </BMText>);
        }
        // (4) Item is provided
        if (item) {
            return item;
        }
        // Default
        return null;
    };
    return <View style={containerStyle}>{renderAdditionalComponent()}</View>;
}
export default memo(DateCellAdditionalSlot);
const componentStyles = (BMComponents) => {
    return StyleSheet.create({
        textInformation: {
            textAlign: 'center',
        },
        container: {
            position: 'absolute',
            alignItems: 'center',
            justifyContent: 'center',
        },
        topContainer: {
            top: 6,
        },
        bottomContainer: {
            bottom: 6,
        },
    });
};
